import styled from 'styled-components';

export const LoadingContainer = styled.div`
  text-align: center;
  margin: 10px;
`;
